import { CountiesEnum } from '../../../api/models';

export const countiesMap = {
  [CountiesEnum.Ab]: 'Alba',
  [CountiesEnum.Ar]: 'Arad',
  [CountiesEnum.Ag]: 'Argeş',
  [CountiesEnum.Bc]: 'Bacău',
  [CountiesEnum.Bh]: 'Bihor',
  [CountiesEnum.Bn]: 'Bistrița Năsăud',
  [CountiesEnum.Bt]: 'Botoșani',
  [CountiesEnum.Br]: 'Brăila',
  [CountiesEnum.Bv]: 'Brașov',
  [CountiesEnum.B]: 'București',
  [CountiesEnum.Bz]: 'Buzău',
  [CountiesEnum.Cl]: 'Călăraşi',
  [CountiesEnum.Cs]: 'Caraș-Severin',
  [CountiesEnum.Cj]: 'Cluj',
  [CountiesEnum.Ct]: 'Constanța',
  [CountiesEnum.Cv]: 'Covasna',
  [CountiesEnum.Db]: 'Dâmbovița',
  [CountiesEnum.Dj]: 'Dolj',
  [CountiesEnum.Gl]: 'Galați',
  [CountiesEnum.Gr]: 'Giurgiu',
  [CountiesEnum.Gj]: 'Gorj',
  [CountiesEnum.Hr]: 'Harghita',
  [CountiesEnum.Hd]: 'Hunedoara',
  [CountiesEnum.Il]: 'Ialomița',
  [CountiesEnum.Is]: 'Iași',
  [CountiesEnum.If]: 'Ilfov',
  [CountiesEnum.Mm]: 'Maramureș',
  [CountiesEnum.Mh]: 'Mehedinți',
  [CountiesEnum.Ms]: 'Mureș',
  [CountiesEnum.Nt]: 'Neamț',
  [CountiesEnum.Ot]: 'Olt',
  [CountiesEnum.Ph]: 'Prahova',
  [CountiesEnum.Sj]: 'Sălaj',
  [CountiesEnum.Sm]: 'Satu-Mare',
  [CountiesEnum.Sb]: 'Sibiu',
  [CountiesEnum.Sv]: 'Suceava',
  [CountiesEnum.Tr]: 'Teleorman',
  [CountiesEnum.Tm]: 'Timiș',
  [CountiesEnum.Tl]: 'Tulcea',
  [CountiesEnum.Vl]: 'Vâlcea',
  [CountiesEnum.Vs]: 'Vaslui',
  [CountiesEnum.Vn]: 'Vrancea',
};

export const counties = [
  { label: 'Alba', value: 'AB' },
  { label: 'Arad', value: 'AR' },
  { label: 'Argeş', value: 'AG' },
  { label: 'Bacău', value: 'BC' },
  { label: 'Bihor', value: 'BH' },
  { label: 'Bistrița Năsăud', value: 'BN' },
  { label: 'Botoșani', value: 'BT' },
  { label: 'Brăila', value: 'BR' },
  { label: 'Brașov', value: 'BV' },
  { label: 'București', value: 'B' },
  { label: 'Buzău', value: 'BZ' },
  { label: 'Călăraşi', value: 'CL' },
  { label: 'Caraș-Severin', value: 'CS' },
  { label: 'Cluj', value: 'CJ' },
  { label: 'Constanța', value: 'CT' },
  { label: 'Covasna', value: 'CV' },
  { label: 'Dâmbovița', value: 'DB' },
  { label: 'Dolj', value: 'DJ' },
  { label: 'Galați', value: 'GL' },
  { label: 'Giurgiu', value: 'GR' },
  { label: 'Gorj', value: 'GJ' },
  { label: 'Harghita', value: 'HR' },
  { label: 'Hunedoara', value: 'HD' },
  { label: 'Ialomița', value: 'IL' },
  { label: 'Iași', value: 'IS' },
  { label: 'Ilfov', value: 'IF' },
  { label: 'Maramureș', value: 'MM' },
  { label: 'Mehedinți', value: 'MH' },
  { label: 'Mureș', value: 'MS' },
  { label: 'Neamț', value: 'NT' },
  { label: 'Olt', value: 'OT' },
  { label: 'Prahova', value: 'PH' },
  { label: 'Sălaj', value: 'SJ' },
  { label: 'Satu-Mare', value: 'SM' },
  { label: 'Sibiu', value: 'SB' },
  { label: 'Suceava', value: 'SV' },
  { label: 'Teleorman', value: 'TR' },
  { label: 'Timiș', value: 'TM' },
  { label: 'Tulcea', value: 'TL' },
  { label: 'Vâlcea', value: 'VL' },
  { label: 'Vaslui', value: 'VS' },
  { label: 'Vrancea', value: 'VN' },
];
